import React, { useEffect, useState } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import CommonInput from "./CommonInput";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { GET_SERVICES_TYPES } from "../../../services/ApiCalls";
import { useSearchParams } from "react-router-dom";
import Step1 from "./Step1";

const requiredString = (name) =>
  z
    .string()
    .trim()
    .min(1, { message: `${name} is required` });

const getSchema = () => {
  return z.object({
    customerEmail: z
      .string()
      .email({ message: "Invalid email format" })
      .nonempty("Email is required"),
    customerName: requiredString("Name"),
    customerMobileNumber: requiredString("Mobile number"),
    customerCountryCode: requiredString("Country Code"),
    // selectedService: z
    //   .object({
    //     value: z.string(),
    //     label: z.string(),
    //   })
    //   .optional()
    //   .refine((val) => !!val, {
    //     message: "Please select a service",
    //   }),
  });
};

const Step0 = ({
  setStep,
  services,
  setSelectedService,
  selectedService,
  setServiceTypes,
  setFormData,
  step0FormData,
  setStep0FormData,
  serviceTypes,
  pickUpListing
}) => {

  const [step1FormData, setStep1FormData] = useState({});

  const schema = getSchema();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    getValues,
    trigger,
  } = useForm({
    resolver: zodResolver(schema),

    defaultValues: { ...step0FormData },
  });

  const handleServiceSelect = async (option) => {
    let type = option.value;
    try {
      const res = await GET_SERVICES_TYPES({ type, status: "active" });
      console.log(res);
      if (res.data.status === "success") {
        setServiceTypes(
          res.data?.data?.map((item) => {
            const additionalFields = (
              <div className="d-flex justify-content-between">
                <img
                  src={item.image}
                  alt={item.name}
                  style={{ width: "30px", height: "30px" }}
                />
                <span>{item.name}</span>
                <span style={{ color: "gray" }}> {item.weightCapacity}</span>
              </div>
            );

            return {
              label: additionalFields,
              labelValue: item.name,
              weight: item.weightCapacity,
              value: item.type
            };
          })
        );
      } else {
        console.error("Failed to fetch service details", res.error);
      }
    } catch (error) {
      console.error("Error fetching service details:", error);
    }
  };

  useEffect(() => {
    handleServiceSelect({ value: "PickupDrop" })
  }, [])

  const onSubmit = (data) => {
    // if (!data.selectedService) {
    //   return;
    // }
    data = { ...data, selectedService: { label: "PickupDrop", value: "PickupDrop" } }
    setSelectedService({ label: "PickupDrop", value: "PickupDrop" })
    setStep0FormData(data);
    console.log(data, "checkdata");

    setStep(1);
  };
  return (
    <>
      <div className="top py-2"></div>
      <Form onSubmit={handleSubmit(onSubmit)} className="bookingForm">
        <Row>
          {/* <Col md="12" className="my-2">
            <label htmlFor="serviceSelect" className="form-label m-0">
              Select Service
            </label>
            <Select
              id="serviceSelect"
              className={"bg-transparent"}
              classNamePrefix="rental"
              options={services}
              value={selectedService}
              onChange={(option) => {
                setSelectedService(option);
                setValue("selectedService", option, { shouldValidate: true });
                handleServiceSelect(option);
              }}
              styles={{
                container: (baseStyles) => ({
                  ...baseStyles,
                  width: "100%",
                }),
                control: (baseStyles) => ({
                  ...baseStyles,
                  backgroundColor: "transparent",
                  borderRadius: "5px",
                }),
              }}
            />
            {errors.selectedService && (
              <p className="text-danger">{errors.selectedService.message}</p>
            )}
          </Col> */}
          <Col md="6" className="my-2">
            <label htmlFor="customerName" className="form-label m-0">
              Name
            </label>
            <CommonInput
              id="customerName"
              register={register}
              errors={errors}
              name={"customerName"}
            />
          </Col>
          <Col lg="6" className="my-2">
            <label htmlFor="customerEmail" className="form-label m-0">
              Email
            </label>
            <CommonInput
              id="customerEmail"
              register={register}
              errors={errors}
              name={"customerEmail"}
            />
          </Col>
          <Col md="6" className="my-2">
            <label htmlFor="customerMobileNumber" className="form-label m-0">
              Mobile Number
            </label>
            <PhoneInput
              id="customerMobileNumber"
              value={watch("customerMobileNumber")}
              onChange={(data, { dialCode }) => {
                setValue("customerMobileNumber", data, {
                  shouldValidate: true,
                });
                setValue("customerCountryCode", dialCode, {
                  shouldValidate: true,
                });
              }}
              country={"us"} // Default country
            />
            {errors.customerMobileNumber && (
              <p className="text-danger">
                {errors.customerMobileNumber.message}
              </p>
            )}
          </Col>
          <Col lg="12" className="my-4 mt-4">
            <Button
              type="submit"
              className="btn d-flex align-items-center justify-content-center commonBtn w-auto mx-auto"
            >
              Next
            </Button>
          </Col>

        </Row>
      </Form>
    </>
  );
};

export default Step0;
